import { useCountdownTimer } from '../../../hooks';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface MonetizationWidgetTimerProps {
  endDate: Date;
  onEnd: () => void;
  extended: boolean;
}

export function MonetizationWidgetTimer(props: MonetizationWidgetTimerProps) {
  const { endDate, onEnd, extended } = props;
  const { timer, isExpired } = useCountdownTimer({ onEnd, endDate });
  if (isExpired) return null;
  return <GeneralWidgetTimer extended={extended} timerValue={timer} />;
}
